module.exports = __webpack_public_path__ + "img/won1.0888e389.png";